import * as KeyCodes from './keycodes';
export default function smartSuggestionsPluginTrigger(evt, editor) {
    if (evt.eventType === 2 /* KeyUp */) {
        var keyboardEvt = evt.rawEvent;
        if (keyboardEvt.which === KeyCodes.ENTER || keyboardEvt.which === KeyCodes.SPACE) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=smartSuggestionsPluginTrigger.js.map